module.exports = __webpack_public_path__ + "img/logo_slyj.2df0af6a.png";